import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

const StudentBulkUploadHelper = {
  /**
   * Queue an async bulk-student upload.
   * Backend responds 202 with { jobId, totalRecords } — the heavy work then
   * runs server-side, so the browser only has to remember the jobId.
   * NOTE: we let ApiHelper.upload build the multipart body; never hand-set the
   * Content-Type or the multipart boundary would be lost.
   */
  uploadStudents: function ({ file, collegeId, batch, semester }) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('college_id', collegeId);
    if (batch) formData.append('batch', batch);
    if (semester) formData.append('current_semester', semester);
    return ApiHelper.upload(API_ENDPOINTS.ADMIN.STUDENTS_BULK_UPLOAD, formData);
  },

  /** Poll the status of a queued upload job. */
  getJobStatus: function (jobId) {
    return ApiHelper.get(API_ENDPOINTS.ADMIN.STUDENTS_BULK_UPLOAD_JOB(jobId));
  },
};

export default StudentBulkUploadHelper;
